import React from 'react';
import s from './BurgerMenu.scss';

export default class BurgerMenu extends React.Component {
    render() {
      const {open, toggleOpen } = this.props
      return (
        <div className={s.menuContainer}>
          <div 
              className={[s.burgerContainer, open ? s.change : ''].join(' ')}         
              onClick={toggleOpen}
          >
              <div className={`${s.burgerMenu} ${s.bar1}`}></div>
              <div className={`${s.burgerMenu} ${s.bar2}`}></div>
              <div className={`${s.burgerMenu} ${s.bar3}`}></div>
          </div>
          <div className={[s.menu, !open ? s.hidden : ''].join(' ')}>  
            {this.props.children({ toggleOpen: toggleOpen })}
          </div>      
      </div>);
    }
  }
